import { connect } from 'react-redux'

import Actions from '../../Actions/Creators'
import HealthLocker from './Component/HealthLocker'
import Phi from './../../Phi/Phi'
import Constants from '../../Phi/Constants'
import { stat } from 'fs'

const getDocuments = (state, props) =>  state.organization && state.organization.reqDoc && state.organization.reqDoc[props.documentGroup] 

const getDocumentType = (documents) => {
  const keys = Object.keys(documents)
  
  let docArray = keys.map(element => ({ 
    value: documents[element].length, 
    key: element, 
    label: Constants.documentCategoryLabel[element] 
      ? Constants.documentCategoryLabel[element].toUpperCase() 
      : 'OTHERS' 
  }))
  return docArray.sort( (obj1, obj2) => { return parseInt(obj2.value) - parseInt(obj1.value) })
}

const mapStateToProps = (state, ownProps) =>{

  const documents = Constants.getCategorizedDocuments(getDocuments(state, ownProps) || [])
  const documentTypes = getDocumentType(documents || [])
  let contentNode = ownProps.contentNode

  const child = ownProps.studentProfile
  if (!!!contentNode && ownProps.isStudent) {
    contentNode = state.organization.studentContentIds[child.uuid]
  }

  const userRole = Phi.User.roles();
  const userProfile = Phi.User.profile();

  return {
    
    roleType: userRole && userRole.length && userRole[0].role_type_id,
    userId: userProfile && userProfile.user_id,
    
    documents: documents || [],
    documentTypes: documentTypes || [],
    contentNode: contentNode,


    // reqDoc: state.organization.reqDoc,
    // contentId: state.organization && state.organization.currentProgram && state.organization.currentProgram.organization_custom_json && state.organization.currentProgram.organization_custom_json.schoolContentID || null,
    // updatedContentNodeId: state.organization.currentOrganizationContentId,
    // inOrganizationId:  state.organization && state.organization.currentProgram && state.organization.currentProgram.in,
    // orgData: state.organization && state.organization.currentProgram,
    // org: state.organization,
    // roleType: userRole && userRole.length && userRole[0].role_type_id
  }
}

const mapDispatchToProps = (dispatch) => ({

  uploadDocuments: (fileObj, contentId, category, fileGroup, fileCustom, uuId) => dispatch(Actions.onFileSubmit(fileObj, contentId, category, fileGroup, fileCustom, uuId)),
  removeDocuments: (id, targetID, srcID, category, fileGroup) => dispatch(Actions.removeDoc(id, targetID, srcID, category, fileGroup)),
  fetchHealthLocker: (contentId, group) => dispatch(Actions.fetchAllDocs(contentId, group)),
  
  saveSchoolContentNode: (organizationId, payload) => dispatch(Actions.updateOrganization(organizationId, payload)),
  saveStudentContentNode: (payload) => dispatch(Actions.updateStudent(payload, {action: Actions.responseUpdateChildUser})),

});

export default connect(mapStateToProps, mapDispatchToProps)(HealthLocker)



// WEBPACK FOOTER //
// ./src/Containers/HealthLockerContainer/index.js